import { rem } from 'polished';
import styled from 'styled-components';

const componentHeight = rem('34px');

export const StyledArrow = styled.span`
  position: absolute;
  right: 0;
  bottom: ${rem('6px')};
  display: block;
  width: ${({ theme }) => rem(theme.spacings.m)};
  height: ${({ theme }) => rem(theme.spacings.m)};
  pointer-events: none;

  svg {
    width: ${rem('11px')};
    height: auto;
  }
`;

export const StyledLabel = styled.label`
  width: 100%;
  height: 100%;
  font-size: ${rem('22px')};
  line-height: ${componentHeight};
  pointer-events: none;
`;

export const StyledSelect = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  text-indent: 0;
  background-color: transparent;
  border: none;
  opacity: 0;
  appearance: none;
`;

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${rem('50px')};
  height: ${componentHeight};
`;
